<template>
  <p class="text-xs text-gray-500">
    {{ $t('footer.description') }}
  </p>
  <p class="text-xs text-gray-500">
    {{ $t('footer.disclaimer') }}
  </p>
</template>
